module.exports = __webpack_public_path__ + "static/media/tabs-battles-regular.0dcff3eb.png";